// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__+o6ll","active":"Modal_active__4hvex","content":"Modal_content__SJejH","title":"Modal_title__Hwfd2","close":"Modal_close__HKpBA"};